import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { ICliente, ICoordenadas, IFilter, IListado, IQueryParam, ISirena, IUsuario } from 'modelos/src';
import { Subscription } from 'rxjs';
import { ListadosService } from 'src/app/auxiliares/servicios/listados.service';
import { AuthService } from '../../login/auth.service';
import { estadoSirena } from 'src/app/auxiliares/mapbox/sirena-estado';

@Component({
  selector: 'app-mapa-mapbox',
  templateUrl: './mapa-mapbox.component.html',
  styleUrl: './mapa-mapbox.component.scss',
  standalone: false,
})
export class MapaMapboxComponent implements OnInit, OnDestroy {
  private listadosService = inject(ListadosService);
  private authService = inject(AuthService);

  public loading = signal(true);
  public sirenas: ISirena[] = [];
  public clientes: ICliente[] = [];
  public sirenaSeleccionada?: (ISirena & { estado: string }) | null;

  public mostrarSirenas = true;
  public mostrarZonas = true;
  public filtroClientes: string[] = [];
  public filtroOnline?: boolean;
  public center?: ICoordenadas;
  public customPosition?: ICoordenadas;
  public verActualizaciones = false;

  private sirenas$?: Subscription;
  private usuario?: IUsuario;
  private clientesTotales = 0;

  private async listarSirenas(): Promise<void> {
    const filter: IFilter<ISirena> = { geojson: { $exists: true } } as IFilter<ISirena>;
    const queryParams: IQueryParam = {
      select: 'chipId actualizando online sonidoEncendido luzEncendida ubicacionGps rssi versionFirmware tipo geojson idCliente',
      filter: JSON.stringify(filter),
    };
    this.sirenas$?.unsubscribe();
    this.sirenas$ = this.listadosService
      .subscribe<IListado<ISirena>>('sirenas', queryParams)
      .subscribe((data) => {
        this.sirenas = data.datos;
        this.loading.set(false);
      });
    await this.listadosService.getLastValue('sirenas', queryParams);
  }

  public clientesChange(clientes: ICliente[]): void {
    this.clientes = clientes;
    this.clientesTotales = Math.max(this.clientesTotales, clientes.length);
    // flotante emite TODOS los clientes cuando no hay selección -> no filtrar
    const todos = clientes.length > 0 && clientes.length >= this.clientesTotales;
    this.filtroClientes = todos ? [] : clientes.map((c) => c._id!).filter(Boolean);
  }

  public estadoChange(online: boolean | undefined): void {
    this.filtroOnline = online;
  }

  public mostrarSirenasChange(v: boolean): void {
    this.mostrarSirenas = v;
  }

  public mostrarClientesChange(v: boolean): void {
    this.mostrarZonas = v;
  }

  public geocode(coord: ICoordenadas): void {
    this.center = coord;
    this.customPosition = coord;
  }

  public onSirenaClick(s: ISirena): void {
    this.sirenaSeleccionada = { ...s, estado: estadoSirena(s) };
  }

  public cerrarIsla(): void {
    this.sirenaSeleccionada = null;
  }

  async ngOnInit(): Promise<void> {
    this.usuario = this.authService.getUsuario();
    this.verActualizaciones = !!this.usuario?.cliente?.configuracion?.verActualizaciones;
    await this.listarSirenas();
  }

  ngOnDestroy(): void {
    this.sirenas$?.unsubscribe();
  }
}
